import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { SmartToastService } from '@shared/services/smartToast.service';

@Component({
  selector: 'app-program-permalink-actions',
  templateUrl: './program-permalink-actions.component.html',
  styleUrls: ['./program-permalink-actions.component.scss'],
})
export class ProgramPermalinkActionsComponent implements OnInit {
  @Input() programid: string;

  constructor(private popCtrl: PopoverController, private cookie: CookieService, private smartToastService: SmartToastService) {}

  ngOnInit() {}

  copyLink(type: string) {
    let link;
    if (type === 'admin') {
      link = `${window.location.origin}/programs/details/${this.programid}`;
    }
    if (type === 'trainee') {
      link = `${environment.app}/program/${this.programid}?mgmttype=permalink`;
    }

    // Copy the link to the clipboard
    navigator.clipboard.writeText(link).then(() => {
      this.smartToastService.show('Link copied to clipboard', 'success', 3000);
    });
    this.popCtrl.dismiss();
  }

  openLink(type: string) {
    let link;
    if (type === 'admin') {
      link = `${window.location.origin}/programs/details/${this.programid}`;
    }
    if (type === 'trainee') {
      link = `${environment.app}/program/${this.programid}?mgmttype=permalink`;
      this.cookie.set('mgmt_token', '', 30, '/', '.amopportunities.org', true, 'Lax');
    }
    // Open the link in a new tab
    window.open(link, '_blank');
    this.popCtrl.dismiss();
  }
}
